<template>
  <div class="text-gray-600">
    <div class="pt-12 px-3 md:pt-10 md:text-center mb-12 md:mb-10">
      <h1 class="ota-h1 mb-5" v-text="$t('CustomerService.CustomerServiceTitle')" />
      <p class="ota-p16 mb-10" v-text="$t('CustomerService.CustomerServiceSubTitle')" />
      <div class="md:text-center">
        <OButton variant="secondary" @click="onFAQClick">
          <span v-text="$t('CustomerService.SeeFAQ')" />
        </OButton>
      </div>
    </div>
    <div id="faq" class="small-container py-12 md:py-20">
      <DynamicFAQ :blocks="blocks" />
    </div>
    <div class="small-container my-12 md:py-20">
      <CustomerServiceFaq :is-women="isWomen" />
    </div>
    <ContactBlock class="lg:pb-20" :locale="locale" />
    <div class="max-w-44rem pb-12 py-20 mb-20">
      <p class="o-heading-4 mb-3" v-text="$t('CustomerService.Footer.Title')" />
      <i18n tag="p" class="o-body" path="CustomerService.Footer.Description">
        <template #link>
          <NuxtLink
            :to="$i18n.localePath({ name: 'contact' })"
            class="o-body underline"
          >
            {{ $t('CustomerService.Footer.ClickHere') }}
          </NuxtLink>
        </template>
      </i18n>
    </div>
    <div v-if="reviewData" class="flex justify-center pb-12 pt-24 md:pt-32">
      <AggregateRating v-bind="reviewData" />
    </div>
  </div>
</template>

<script>
import { Locales } from '@/enums/general'
import ContactBlock from '@/components/ContactBlock'
import AggregateRating from '@/components/AggregateRating'
import CustomerServiceFaq from '@/components/CustomerServiceFaq'
import DynamicFAQ from '@/components/DynamicFAQ'
import OButton from '@/components/OButton'

export default {
  name: 'FAQPage',
  components: { ContactBlock, AggregateRating, CustomerServiceFaq, DynamicFAQ, OButton },
  props: {
    blocks: {
      type: Array,
      default: () => ([]),
      validator: value => value.every(obj => ['title', 'image', 'questions'].every(prop => obj.hasOwnProperty(prop)))
    },
    locale: {
      type: String,
      default: Locales.nl
    },
    reviewData: {
      type: Object,
      default: () => ({})
    },
    isWomen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    enhancedBlocks () {
      return this.blocks
    }
  },
  methods: {
    onFAQClick () {
      const faqDiv = document.getElementById('faq')

      if (faqDiv) {
        faqDiv.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
.small-container {
  @apply mx-auto;
  max-width: 119.2rem;
}

.max-w-44rem {
  @apply mx-auto text-center px-3;
  max-width: 44rem;
}

.new-gray {
  color: #5A5A58;
}

.arrow-right {
  @apply fill-gray-600 cursor-pointer text-center h-4 w-4 inline;
}
</style>
